import { render, staticRenderFns } from "./AddToWorkflow.vue?vue&type=template&id=1ba61e75&scoped=true&"
import script from "./AddToWorkflow.vue?vue&type=script&lang=js&"
export * from "./AddToWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba61e75",
  null
  
)

export default component.exports